import React, {Component} from 'react';
import './UploadedFile.scss';
import {Storage} from "../../../shared/services/aws";
import ReactTooltip from 'react-tooltip';
import classnames from 'classnames';

const getFileName = (document) => {
  if (document.file && document.file.displayName) {
    return document.file.displayName;
  }

  let segments = document.file.name.split('/');
  return segments[segments.length - 1];
};

class UploadedFile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      link: null
    };
  }

  componentDidMount() {
    Storage.get(this.props.file.file.name)
      .then(result => {
        this.setState({
          link: result
        })
      });
  }

  handleDragStart(e, index) {
    if (this.props.canDelete) {
      this.props.onDragStart(index);
    }

    document.body.style.overflow = "hidden";
  }

  handleDragOver(e) {
    e.preventDefault();
    e.stopPropagation();

    if (this.props.canDelete) {
      this.props.onDragOver(e);
    }
  }

  handleTouchMove(e) {
    if (this.props.canDelete) {
      const target = document.elementFromPoint(e.touches[0].clientX, e.touches[0].clientY)
      let index = target.id.split('file-');

      if (index.length <= 1) {
        index = target.className.split('file-index-');
      }

      if (index.length > 1) {
        index = parseInt(index[1]);
        if (Number.isInteger(index)) {
          this.props.onHandleMove(index, target.id, target.className, e.touches[0].clientX);
        }
      }
      else {
        index = target.id.split('folder-');
        if (index.length > 1) {
          index = parseInt(index[1]);
        }

        this.props.onHandleMove(index, target.id, target.className, e.touches[0].clientX);
      }
    }
  }

  handleDragEnd(e) {
    if (this.props.canDelete) {
      this.props.onDragEnd();
    }

    document.body.style.overflow = "auto";
  }

  getFileIndexClass() {
    return `file-index-${this.props.index}`;
  }

  render() {
    return (
      <div className="file-container">
        <div
          className="file-wrapper"
          id={`file-${this.props.index}`}
          draggable={true}
          onDragStart={(e) => this.handleDragStart(e, this.props.index)}
          onTouchStart={(e) => this.handleDragStart(e, this.props.index)}
          onDragOver={(e) => this.handleDragOver(e)}
          onTouchMove={(e) => this.handleTouchMove(e)}
          onDragEnd={(e) => this.handleDragEnd(e)}
          onTouchEnd={(e) => this.handleDragEnd(e)}
        >
          <a
            className={classnames('uploaded-file', this.getFileIndexClass())}
            href={this.state.link}
            target="_blank"
            onDragStart={(e) => false}
          >
            {this.props.canDelete
              ? <div className={classnames('delete-file', this.getFileIndexClass())} onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                this.props.onDelete(this.props.file)
              }}>
                <span className={classnames('fa fa-trash', this.getFileIndexClass())} />
              </div>
              : null}

            {this.props.canDelete &&
              <div className={classnames('edit-file-permissions', this.getFileIndexClass())} onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                this.props.onEditPermissions(this.props.file)
              }} >
                <i className={classnames('fa fa-lock', this.getFileIndexClass())} />
              </div>
            }
            <div className={classnames('file-icon', this.getFileIndexClass())}>
              <i className={classnames('fa fa-file', this.getFileIndexClass())} />
            </div>
            {this.props.file.date &&
            <div className={classnames('file-date', this.getFileIndexClass())}>
              {this.props.file.date}
            </div>
            }
            <ReactTooltip
              place="bottom"
              className="customTheme"
              effect="solid"
            />
            <div className={classnames('file-name', this.getFileIndexClass())} data-tip={getFileName(this.props.file)}>
              {getFileName(this.props.file)}
            </div>
          </a>
        </div>

        <div className={classnames('new-position-placeholder', this.props.placeholderClass)}>

        </div>
      </div>
    );
  }
}

// const UploadedFile = ({file, canDelete, onDelete}) => {
//   let link = null;
//   Storage.get(file.file.name)
//     .then(result => link = result);
//
//   return (
//     <a className="uploaded-file" href={link} target="_blank">
//       {canDelete
//         ? <div className="delete-file" onClick={(e) => {e.stopPropagation(); e.preventDefault(); onDelete(file)}}>
//           <i className="fa fa-trash" />
//         </div>
//         : null}
//       <div className="file-icon">
//         <i className="fa fa-file" />
//       </div>
//       <div className="file-name">
//         {getFileName(file)}
//       </div>
//     </a>
//   );
// }

export default UploadedFile
